import { mergeRoleMenus } from '@accessManager/utils/mergeRoleMenus';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type AclConfig } from '@store/skeletor/permissions/types';
import { deleteItem, getObject, saveObject } from '@utils/localStorage';

import { STORAGE_KEYS } from './constants';
import { initialUserState } from './initialState';
import { type User } from './types';

const slice = createSlice({
  name: 'User',
  initialState: initialUserState,
  reducers: {
    userLoggedIn: (state, action: PayloadAction<User>) => {
      const { username, email, name, picture, roles = [], id } = action.payload;
      state.user.username = username;
      state.user.email = email;
      state.user.name = name;
      state.user.picture = picture;
      state.user.roles = roles;
      state.user.id = id;
    },
    saveUserMenuElements: (state, action: PayloadAction<AclConfig[]>) => {
      const menuElements = mergeRoleMenus(action.payload);
      state.menu.elements = menuElements;
      state.menu.isLoading = false;
    },
    impersonateUser: (state, action: PayloadAction<User>) => {
      const user = action.payload;
      state.impersonatedUser.user = user;
      state.impersonatedUser.isLoading = false;
      saveObject(STORAGE_KEYS.IMPERSONATED_USER, user);
    },
    clearImpersonatedUser: state => {
      state.impersonatedUser.user = undefined;
      state.impersonatedUser.isLoading = false;
      deleteItem(STORAGE_KEYS.IMPERSONATED_USER);
    },
    initFetchImpersonatedUser: state => {
      state.impersonatedUser.isLoading = true;
    },
    fetchImpersonatedUser: state => {
      state.impersonatedUser.isLoading = true;
      const user = getObject<User>(STORAGE_KEYS.IMPERSONATED_USER);
      state.impersonatedUser.user = user;
      state.impersonatedUser.isLoading = false;
    },
  },
});

const { reducer } = slice;

export const {
  userLoggedIn,
  saveUserMenuElements,
  impersonateUser,
  clearImpersonatedUser,
  initFetchImpersonatedUser,
  fetchImpersonatedUser,
} = slice.actions;

export default reducer;
